import React from "react"
import { Route } from "react-router-dom"
import { autobind } from "core-decorators"
import slug from "constants/slug"

import OverviewDashboard from "containers/dashboard/OverviewDashboard"
import LoginRoute from "./loginRoute"
import LayoutRoute from "layout/default-sidebar-layout/routeCombine"
import LanguageLocaleRoute from "containers/language-locale"
import UserRoute from "containers/user"
import QARoute from "containers/qa"
import OrganizationRoute from "containers/organization"
import LicenseRoute  from 'containers/license'
@autobind
export default class RouteDefault extends React.Component {
  render() {
    return (
      <div>
        <LayoutRoute path="/" exact component={OverviewDashboard} />
        <Route path={slug.login} exact component={LoginRoute} />
        <LayoutRoute
          path={slug.languageLocale.base}
          component={LanguageLocaleRoute}
        />
        <LayoutRoute path={slug.user.base} component={UserRoute} />
        <LayoutRoute
          path={slug.organization.base}
          component={OrganizationRoute}
        />
        <LayoutRoute
          path={slug.license.base}
          component={LicenseRoute}
        />
        <LayoutRoute path={slug.qa.base} component={QARoute} />
      </div>
    )
  }
}

//



// WEBPACK FOOTER //
// ./src/navigation/routes/index.js